module.exports = __webpack_public_path__ + "static/media/Logs.7138c7f9.png";